module.exports = __webpack_public_path__ + "static/media/visa.841aeddf.png";